<template lang="pug">
#businessDetailView.custom-container(v-if="!loading")
  .section-title Detalle empresa
  b-breadcrumb.breadcrumb(:items="breadcrumbs")
  .table-view
    h3.detail-title Editar {{business.name}}
    hr
    CreateEditForm.mx-3.pt-3(
      :selectedBusiness="selectedBusiness",
      action="edit",
      :hideModal="postSaveForm",
      :makeToast="makeToast",
      hideCancel=true
    )
    ListBusinessServices
    ListUserBusiness
    ListPasswordBusiness
</template>
<script>
import CreateEditForm from "../components/business/CreateEditForm";
import ListBusinessServices from "../components/business/ListBusinessServices";
import ListUserBusiness from "../components/business/UsersBusiness/ListUserBusiness";
import ListPasswordBusiness from "../components/business/PasswordsBusiness/ListPasswordBusiness";

import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    CreateEditForm,
    ListBusinessServices,
    ListUserBusiness,
    ListPasswordBusiness
  },
  data() {
    return {
      selectedBusiness: {},
      loading: true,
      breadcrumbs: [
        {
          text: 'Inicio',
          to: { name: 'Home' }
        },
        {
          text: 'Empresas',
          to: { name: 'Business' }
        },
        {
          text: 'Detalle servicio',
          active:true
        },
      ]
    };
  },
  computed: {
    ...mapGetters(["business"]),
  },
  async created() {
    const id = +this.$route.params.id;
    await this.getBusiness(id);
    this.selectedBusiness = this.business;
    this.loading = false;
  },
  methods: {
    ...mapActions(["getBusiness"]),
    makeToast(variant = null, body, title) {
      this.$bvToast.toast(body, {
        title,
        variant,
        solid: true,
        hide: true,
        autoHideDelay: 3000,
      });
    },
    postSaveForm() {
      const id = +this.$route.params.id;
      this.getBusiness(id);
    },
  },
};
</script>